import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Chart.png'


const _withScopeId = n => (_pushScopeId("data-v-5c7a1fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content d-flex flex-column" }
const _hoisted_2 = { class: "header d-flex align-items-baseline justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Statistics", -1))
const _hoisted_4 = { class: "date" }
const _hoisted_5 = { class: "latest-mov mt-2" }
const _hoisted_6 = { class: "segment-header d-flex justify-content-between mx-3 my-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "titlebox" }, "Latest Movements", -1))
const _hoisted_8 = { class: "stats d-flex gap-3" }
const _hoisted_9 = { class: "done d-flex flex-column align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hv" }, null, -1))
const _hoisted_11 = { class: "pending d-flex flex-column align-items-center" }
const _hoisted_12 = { class: "stats-table" }
const _hoisted_13 = { class: "table table-sm table-responsive" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-top" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Conductor Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Car License"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Entry Date"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Departure Date"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye" }, null, -1))
const _hoisted_16 = { class: "cards d-flex align-items-center gap-3" }
const _hoisted_17 = { class: "card cars d-flex flex-column justify-content-evenly align-items-center" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button carBtn" }, "Register Car", -1))
const _hoisted_21 = { class: "card moves d-flex flex-column justify-content-between align-items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button moveBtn" }, "Open Movement", -1))
const _hoisted_23 = { class: "card gains d-flex flex-column justify-content-between align-items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icongain align-self-end",
  alt: "chartIcon"
}, null, -1))
const _hoisted_25 = { class: "footer d-flex flex-column align-self-start" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footerTitle" }, "Total Day Win", -1))
const _hoisted_27 = { class: "gainsMoney d-flex justify-content-between align-items-center gap-3" }
const _hoisted_28 = { class: "moneyGain" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formattedDate), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.moveClose.length), 1),
            _createVNode(_component_router_link, {
              to: "/access-closemovement",
              class: "text-reset text-decoration-done"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Done")
              ]),
              _: 1
            })
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_ctx.moveOpen.length), 1),
            _createVNode(_component_router_link, {
              to: "/access-movement",
              class: "text-reset text-decoration-done"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Pending")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movimentacoes, (movimentacao) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: movimentacao.id
              }, [
                _createElementVNode("td", null, _toDisplayString(movimentacao.condutor.nome), 1),
                _createElementVNode("td", null, _toDisplayString(movimentacao.veiculo.placa), 1),
                _createElementVNode("td", {
                  class: _normalizeClass({ 'text-success': movimentacao.saida, 'text-danger': !movimentacao.saida })
                }, _toDisplayString(movimentacao.saida ? 'Closed' : 'Pending'), 3),
                _createElementVNode("td", null, _toDisplayString(movimentacao.entrada), 1),
                _createElementVNode("td", null, _toDisplayString(movimentacao.saida !== null ? movimentacao.saida : '-'), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: _ctx.getActionRoute(movimentacao)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          to: "/register/vehicle",
          class: "align-self-end"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: require('@/assets/open tab.png'),
              alt: "open tab",
              class: "openTab"
            }, null, 8, _hoisted_18)
          ]),
          _: 1
        }),
        _createElementVNode("img", {
          src: require('@/assets/back view of toy car turn right blue.png'),
          alt: "car",
          class: "registerCarImage"
        }, null, 8, _hoisted_19),
        _createVNode(_component_router_link, { to: "/register-vehicle" }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_router_link, { to: "/register-movement" }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, "$" + _toDisplayString(_ctx.dayGain.toFixed(2)), 1),
            _createElementVNode("i", {
              class: _normalizeClass({'bi bi-arrow-down-up': _ctx.previousDayGain == _ctx.dayGain, 'bi bi-arrow-down-up text-success': _ctx.previousDayGain < _ctx.dayGain, 'bi bi-arrow-down-up text-danger': _ctx.previousDayGain > _ctx.dayGain})
            }, null, 2)
          ])
        ])
      ])
    ])
  ]))
}